import {Component, Input} from '@angular/core';

@Component({
  selector: 'pt-details-title',
  template: `
    <div class='dt-title'>
      <span>{{title}}</span>
      <ng-content select='[titleExtra]'></ng-content>
    </div>
  `,
  styles: [`
    .dt-title {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      font-size: 15px;
      font-weight: bold;
    }`]
})
export class DetailsTitleComponent {
  @Input() title: string;
}
